import { useParams } from 'react-router-dom';
import { useSetBreadcrumbName } from 'hooks';
import { getTheme } from 'api/node/themes';

const ThemeBreadcrumb = () => {
  const { themeId } = useParams();

  useSetBreadcrumbName({
    path: `/settings/experiences/themes/${themeId}`,
    query: getTheme,
    variables: { themeId },
    formatData: (data) =>
      Boolean(data?.node) ? `${data?.node?.displayName} ` : null,
  });

  return null;
};

export default ThemeBreadcrumb;
